import { useMemo } from 'react';
import { getMarketKey } from '../_utils/getMarketKey';
import { UseQueryResult } from '@tanstack/react-query';

import type { ReviewItem } from '@/types/api';
import type { MarketStoreListItem } from '../_consts/constants';

interface OrdersByMarket {
  key: string;
  orders: ReviewItem[];
}

export function useOrdersByMarket(
  marketList: MarketStoreListItem[],
  allMarketsResults: UseQueryResult<any>[],
): OrdersByMarket[] {
  return useMemo(() => {
    return marketList.map((market: MarketStoreListItem, idx: number) => {
      const orders = (allMarketsResults[idx]?.data?.data?.[0]?.ReportDetailList ??
        []) as ReviewItem[];
      return { key: getMarketKey(market), orders };
    });
  }, [marketList, allMarketsResults]);
}
